import { generatePath } from "react-router-dom";
import { ARTICLE_EXPORT_GOOGLE_DOC } from "../apiEndPoints";
import { api, convertKeysToCamelCase } from "./api";

export interface GoogleDocExport {
  documentId: string;
  url: string;
}

// exporting an article to a Google Doc in the folder of a connected Google Docs destination
export const googleApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    exportArticleToGoogleDoc: builder.mutation<
      GoogleDocExport,
      { accountId: string; articleId: string; destinationId: string }
    >({
      query: ({ accountId, articleId, destinationId }) => ({
        url: `${generatePath(ARTICLE_EXPORT_GOOGLE_DOC, {
          accountId,
          articleId,
        })}?destination_id=${destinationId}`,
        method: "POST",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      // also on failure: revoked access flags the destination as needing a reconnect
      invalidatesTags: (result, error, { accountId }) => [
        { type: "Destinations", id: accountId },
      ],
    }),
  }),
});

export const { useExportArticleToGoogleDocMutation } = googleApiSlice;
